import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class PurchaseOrderApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.PURCHASE_ORDER);
  }

  getPOLines(purchaseOrderId, params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}po-lines/${purchaseOrderId}/?${queryString}`
      : `${this.getResourceUrl()}po-lines/${purchaseOrderId}/`;

    return this.httpClient.get(url);
  }

  updatePOFile(purchaseOrderId, data) {
    const url = `${this.getResourceUrl()}${purchaseOrderId}/file/`;

    if (data instanceof FormData) {
      return this.httpClient.patch(url, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    } else {
      return this.httpClient.patch(url, data);
    }
  }

  updatePOLines(purchaseOrderId, data) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}po-lines/${purchaseOrderId}/multi-update/`,
      data,
    );
  }

  deletePOLines(purchaseOrderId, data) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}po-lines/${purchaseOrderId}/multi-remove/`,
      data,
    );
  }

  updatePOStatus(purchaseOrderId, data) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${purchaseOrderId}/status/`,
      data,
    );
  }
}

export default new PurchaseOrderApi();
